/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/prefer-regexp-exec */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import { Toast } from '@hb/coffee';
import { VueConstructor } from 'vue';

export class SupportComponents {
  // 映射组件
  static componentsProps: Dictionary<VueConstructor> = {};

  static getComponent(propsName: string): VueConstructor | void {
    if (!SupportComponents.componentsProps[propsName]) {
      Toast(`暂未支持该补充资料项: ${propsName}`);
      return;
    }
    return SupportComponents.componentsProps[propsName];
  }
}

// 匹配所有名称
function regStr(str: string): string {
  str.match(new RegExp(/^\.\/(\w*)\/(\w*)\.tsx$/));
  return RegExp.$1;
}

// 动态引入所有的组件
const requireAll = (requireContext: any) => {
  const pathNameList = requireContext.keys();
  pathNameList.map((item: string) => {
    const pathName: string = regStr(item);

    SupportComponents.componentsProps[
      pathName
    ] = require(`./fields/${pathName}`).default;
  });
};

requireAll((require as any).context('./fields', true, /\.tsx$/));
